import VueCookies from 'vue-cookies';
import db, { auth } from '@/config/firebase';

// Secret code required to register as admin
const ADMIN_SECRET = 'MSDAT_ADMIN_2024';

const checkAdminStatus = async (uid) => {
  try {
    const adminDoc = await db.collection('admins').doc(uid).get();
    return adminDoc.exists;
  } catch (e) {
    return false;
  }
};

export default {
  namespaced: true,
  state: {
    user: VueCookies.get('configurer-user') || null,
    isAdmin: VueCookies.get('configurer-is-admin') === 'true' || false,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      if (user) {
        VueCookies.set('configurer-user', user, '1d');
      } else {
        VueCookies.remove('configurer-user');
      }
    },
    SET_IS_ADMIN(state, value) {
      state.isAdmin = value;
      if (value) {
        VueCookies.set('configurer-is-admin', 'true', '1d');
      } else {
        VueCookies.remove('configurer-is-admin');
      }
    },
  },
  actions: {
    async signUp({ commit }, {
      email, password, organization, adminCode,
    }) {
      try {
        const userCredential = await auth.createUserWithEmailAndPassword(email, password);
        const { uid } = userCredential.user;
        const isAdminRegistration = adminCode === ADMIN_SECRET;

        // If admin code provided, write to admins collection
        if (isAdminRegistration) {
          await db.collection('admins').doc(uid).set({
            email,
            organization: organization || '',
            createdAt: new Date().toISOString(),
          });
        }

        const user = { uid, email, organization };
        commit('SET_USER', user);
        commit('SET_IS_ADMIN', isAdminRegistration);
        return { user, isAdmin: isAdminRegistration };
      } catch (error) {
        console.error('Sign up error:', error);
        throw error;
      }
    },

    async login({ commit }, { email, password }) {
      try {
        const userCredential = await auth.signInWithEmailAndPassword(email, password);
        const { uid } = userCredential.user;
        const isAdmin = await checkAdminStatus(uid);

        const user = { uid, email };
        commit('SET_USER', user);
        commit('SET_IS_ADMIN', isAdmin);
        return { user, isAdmin };
      } catch (error) {
        console.error('Login error:', error);
        throw error;
      }
    },

    async logout({ commit }) {
      try {
        await auth.signOut();
        commit('SET_USER', null);
        commit('SET_IS_ADMIN', false);
      } catch (error) {
        console.error('Logout error:', error);
        throw error;
      }
    },

    async fetchAdmins() {
      try {
        const querySnapshot = await db.collection('admins').get();
        const admins = [];
        querySnapshot.forEach((docSnap) => {
          admins.push({ id: docSnap.id, ...docSnap.data() });
        });
        return admins;
      } catch (e) {
        return [];
      }
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.user,
    currentUser: (state) => state.user,
    isAdmin: (state) => state.isAdmin,
  },
};
